export const ValidationMessage = {
  FULL_NAME_REQUIRED: "Full name field is required.",
  EMAIL_REQUIRED: "Email address field is required.",
  PASSWORD_REQUIRED: "Password field is required.",
  PASSWORD_VALID:
    "Password must has at least 8 characters that include at least 1 lowercase character, 1 uppercase characters, 1 number, and 1 special character in (!@#$%^&*)",
  NEW_PASSWORD_VALID: "New password field is required.",
  CONFIRM_NEW_PASSWORD_VALID: "Confirm new password field is required.",
  CONFIRM_PASSWORD_VALID: "New password and confirm password doesn't match.",
  CONFIRM_PASSWORD_VALID_NEW: "Password and confirm password doesn't match.",
  CONFIRM_PASSWORD: "Password and confirm password doesn't match.",
  ENTER_VALID_EMAIL: "Please enter valid email.",
  FIRST_NAME_REQUIRED: "First name field is required.",
  FIRST_NAME_MIN_LENGTH: "First Name must be at least 1 character.",
  FIRST_NAME_MAX_LENGTH: "First Name cannot exceed 50 characters.",
  TITLE_MAX_LENGTH: "Title cannot exceed 100 characters.",
  SUMMARY_REQUIRED: "summary is required.",
  LAST_NAME_REQUIRED: "last name field is required.",
  LAST_NAME_MIN_LENGTH: "Last Name must be at least 1 character.",
  LAST_NAME_MAX_LENGTH: "Last Name cannot exceed 50 characters.",
  VALID_MOBILE_NO: "Please enter a valid mobile number.",
  MOBILE_NOT_LESS_10: "Mobile number must be at least 10 digits.",
  MOBILE_NOT_GRATER_15: "Mobile number cannot exceed 15 digits.",
  MOBILE_NUMBER_REQUIRED: "Mobile no field is required.",
  INDUSTRY_NAME_REQUIRED: "Business name field is required.",
  INDUSTRY_Type_REQUIRED: "Select industry type.",
  ZIP_CODE_FIELD: "Zipcode field is required.",
  OTP_REQUIRED: "OTP field is required.",
  OTP_INVALID: "Please enter valid otp.",
  ROLE_REQUIRED: "Please select role.",
  TIME_ZONE_REQUIRED: "Please select timezone.",
  CARD_NO_REQUIRED: "Card no field is required.",
  EXPIRE_DATE_REQUIRED: "Expiry date field is required.",
  CVV_REQUIRED: "Expiry date field is required.",
  CARD_HOLDER_NAME_REQUIRED: "Card holder field is required.",
  BUSINESS_NAME_REQUIRED: "Business name field is required.",
  ROLE_REQUIRED_FIELD: "Role field is required.",
  STATUS_REQUIRED: "Status field is required.",
  USER_NAME_REQUIRED: "User name field is required.",
  MANUFACTURER_REQUIRED: "Manufacturer name field is required.",
  LEAD_OWNER_REQUIRED: "Lead owner field is required.",
  LEAD_ASSISTANT_REQUIRED: "Lead assistant field is required.",
  PHONE_REQUIRED: "Phone no field is required.",
  VALID_URL: "Please enter valid url.",
  Lead_Name_REQUIRED: "Lead name field is required.",
  ADDRESS_LINE_One: "Address line one field is required.",
  ADDRESS_LINE_Two: "Address line two field is required.",
  DISTRICT_REQUIRED: "District field is required.",
  CITY_REQUIRED: "City field is required.",
  STATE_REQUIRED: "State field is required.",
  COUNTRY_REQUIRED: "Country field is required.",
  LANDMARK_REQUIRED: "Landmark field is required.",
  PIN_CODE_REQUIRED: "Pin-code field is required.",
  GENDER_REQUIRED: "Gender field is required.",
  OFFICE_NAME_REQUIRED: "Office name field is required.",
  OCCUPATION_NAME_REQUIRED: "Occupation name field is required.",
  DESIGNATION_NAME_REQUIRED: "Designation field is required.",
  DEPARTMENT_NAME_REQUIRED: "Department field is required.",
  OFFICE_LINE_ONE_REQUIRED: "Office address line one field is required.",
  WEBSITE_LINK_REQUIRED: "Website field is required.",
  PAYMENT_TYPE_REQUIRED: "Payment type field is required.",
  PAYMENT_METHOD_REQUIRED: "Payment method field is required.",
  PAYMENT_SCREENSHOT_REQUIRED: "Payment screen shot field is required.",
  RELATION_WITH_REQUIRED: "Relation with field is required.",
  FORGOT_TO_ENTER_MESSAGE: "Did you forgot to enter message.",
  NAME_REQUIRED: "Name field is required.",
  POSITION_REQUIRED: "Position field is required.",
  EVENT_NAME_REQUIRED: "Event name field is required.",
  EVENT_DESCRIPTION_REQUIRED: "Event description field is required.",
  EVENT_ADDRESS_REQUIRED: "Event address field is required.",
  EVENT_HEADER_IMAGE_REQUIRED: "Event header image field is required.",
  EVENT_IMAGE_REQUIRED: "Event image field is required.",
  JOB_TITLE_REQUIRED: "Job title field is required.",
  COMPANY_NAME_REQUIRED: "Company name field is required.",
  JOB_ROLE_REQUIRED: "Job role field is required.",
  YEAR_OF_EXP_REQUIRED: "Year of experience field is required.",
  SALARY_REQUIRED: "Salary field is required.",
  JOB_LOCATION_REQUIRED: "Job location field is required.",
  DESCRIPTION_REQUIRED: "Description field is required.",
  Day_REQUIRED: "Day field is required.",
  RASHI_REQUIRED: "Rasi field is required.",
  DEGREE_REQUIRED: "Degree field is required.",
  COLLEGE_NAME_REQUIRED: "College name field is required.",
  ADDRESS_REQUIRED: "Address field is required.",
  ANNUAL_INCOME_REQUIRED: "Annual income field is required.",
  MARITAL_STATUS_REQUIRED: "Marital status field is required.",
  OCCUPATION_REQUIRED: "Occupation field is required.",
  CONTACT_NAME_REQUIRED: "Contact person field is required.",
  TIME_OF_BIRTH_REQUIRED: "Time of birth field is required.",
  UPLOAD_MULTI_IMAGE_REQUIRED: "Upload more images field is required.",
  PERSONALITY_REQUIRED: "Personality field is required.",
  EDUCATION_REQUIRED: "Education field is required.",
};
